import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ModalRequest from '../modalRequest/modalRequest.vue'

export default {
  components: {HeadDetailsGama, ModalRequest},
  name: 'ClientDetails',
  props: ['selectedSolicitacao'],

  data () {
    return { }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/requests/components/clientDetails/clientDetails.js